import {DeleteOutlined as AntdDeleteOutlined} from '@ant-design/icons';

export default function DeleteOutlined(props) {
  return <AntdDeleteOutlined {...props} />;
}
